/** A first-party plug for the team's own product. Not tied to the token or the pledge. */
export function PromoBanner() {
  return (
    <aside className="promo" aria-label="From the same team">
      From the team behind $TISM: <a href="https://indexsy.com/browserblast-lp/">BrowserBlast, rank on Google in 3 days</a>
    </aside>
  );
}
